import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_evaluateCourse(
    $ids: [ID!]!
    $userCourseStatus: String!
    $url: String
    $evaluationDate: String
  ) {
    User_evaluateCourse(
      ids: $ids
      userCourseStatus: $userCourseStatus
      url: $url
      evaluationDate: $evaluationDate
    ) {
      status
    }
  }
`;

/**
 * Aprueba/cambia el estatus de N userCourses (mismo curso) en una sola llamada.
 *
 * @param {Object} params
 * @param {string[]} params.ids - Array de userCourseId. Mínimo 1.
 * @param {string} params.userCourseStatus - "Aprobado" | "Reprobado" | "Por Cursar".
 * @param {string} [params.url] - S3 key de la evidencia. Omitir si no aplica.
 * @param {string} [params.evaluationDate] - ISO 8601. Omitir para usar fecha actual del backend.
 * @returns {Promise<{ status: boolean, errorMessage?: string }>}
 */
const userEvaluateCourse = async ({ ids, userCourseStatus, url, evaluationDate }) => {
  const variables = { ids, userCourseStatus };
  if (url !== undefined && url !== null && url !== '') {
    variables.url = url;
  }
  if (evaluationDate) {
    variables.evaluationDate = evaluationDate;
  }

  const data = await graphql(mutation, variables);

  if (data?.error) {
    return { status: false, errorMessage: data.errorMessage };
  }
  return data.User_evaluateCourse;
};

export default userEvaluateCourse;
